class GDropdown extends HTMLElement {
  static instances = new Set();
  static handleClickOutside(e) {
    GDropdown.instances.forEach(dropdown => {
      if (!dropdown.contains(e.target)) {
        dropdown.close();
      }
    });
  }

  constructor() {
    super();

    this._selected = this.querySelector('.js-selected');
    this._input = this.querySelector('input');
    this._items = this.querySelectorAll('[data-value]');
  }

  connectedCallback() {
    if (GDropdown.instances.size === 0) {
      window.addEventListener('click', GDropdown.handleClickOutside);
    }

    GDropdown.instances.add(this);
    
    this.addEventListener('click', (e) => {
      if(!this.expanded) {
        this.open();
      } else {
        this.close();
      }
    });

    this._items.forEach(item => item.addEventListener("click", (e) => {
      this.value = item.dataset.value;
    }));
  }

  disconnectedCallaback() {
    GDropdown.instances.delete(this);

    if (GDropdown.instances.size === 0) {
      window.removeEventListener('click', GDropdown.handleClickOutside);
    }
  }

  set value(value) {
    if(value === this._input.value) {
      return;
    }
    const item = this.querySelector(`[data-value="${value}"]`)
    if(item) {
      this.querySelector(`[data-value="${this._input.value}"]`).setAttribute('aria-selected', 'false');
      item.setAttribute('aria-selected', 'true');
      this._selected.innerHTML = item.innerHTML;
      this._input.value = value;
      this.dispatchEvent(new Event('change'));
    } else {
      console.error(`There is no item with value: ${value}`);
    }
  }

  get value() {
    return this._input.value;
  }

  close() {
    this.expanded = false;
  }

  open() {
    this.expanded = true;
  }

  get expanded() {
    return this.getAttribute('aria-expanded') === "true";
  }

  set expanded(value) {
    this.setAttribute('aria-expanded', Boolean(value));
  }
}

window.customElements.define('g-dropdown', GDropdown);

export default GDropdown;